<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="8">
          <div class="page-title">課題列表</div>
        </el-col>
        <el-col :span="16" style="text-align: right;">
          <el-button size="mini" v-if="userInfoRoleRoleId !== teacherRoleId" type="info" @click.native="onAdd">新增課題</el-button>
        </el-col>
      </el-row>

      <div class="page-box">
        <div class="page-content-box">
          <div class="page-content-row">
            <div>
              <div class="search-text">課題編號</div>
              <el-input
                v-model="listQuery.numberLike"
                placeholder="請輸入課題編號"
              ></el-input>
            </div>
            <div>
              <div class="search-text">語言</div>
              <el-select v-model="listQuery.lang" placeholder="請選擇語言">
                <el-option
                  v-for="item in languages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div >
              <div class="search-text">年級</div>
              <el-select v-model="listQuery.gradeId" placeholder="請選擇年級">
                <el-option
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-button size="mini" type="info" @click="onSearch" class="button-el-el">搜尋</el-button>
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column
            prop="number"
            label="課題編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            label="描述"
            align="center"
            width="200px"
          >
            <template slot-scope="{row}">
              <div class="describe-text">{{ row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="scope"
            label="課題範圍(島)"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.scope | scope}}</span>
                <!-- <span v-if="row.lang == 0">{{row.scope | scope}}</span>
                <span v-else>{{row.scope | scopeEn}}</span> -->
          </template>
          </el-table-column>
          <el-table-column
            prop="lang"
            label="語言"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.lang | language}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="gradeId"
            label="年級"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
               <span>{{row.gradeName}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="發佈時間"
            align="center">
           <template slot-scope="{row}">
               <span>{{row.createdAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="updatedAt"
            label="最後更新時間"
            align="center"
            sortable="custom"
          >
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center"
            
          >
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button v-if="userInfoRoleRoleId !== teacherRoleId" type="text" size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId" type="text" size="medium" @click="onDeleteButton(row.id)"
                >刪除</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(row.id)"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getTopics"
    />
    <deleteDialog
      titleCh="您確定要刪除此課題嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getTopics,deleteTopics } from "@/api/topics";
import deleteDialog from "@/components/deleteDialog";
import {getGrades} from '@/api/grade'
export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      isRelease:[
        {
          id: 0,
          name: "未發佈"
        },
        {
          id: 1,
          name: "已發佈"
        }
      ],
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      listQuery: {
        numberLike: null,
        gradeId: null,
        lang: null,
        scope: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
      grades: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getTopics();
    this.getGrades();
  },
  methods: {
    getGrades(){
      getGrades().then(res=>{
        this.grades = res.data
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getTopics();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        }
        if (key === "_limit") {
          this.listQuery[key] = 50;
        }
      })
      this.getTopics();
    },
    onSearch() {
      this.getTopics();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      this.deleteTopics();
    },
    onAdd() {
      let path = `/topic/add`
      this.resolveRouter(path)
    },
    onEditButton(id) {
      let path = `/topic/${id}/edit`
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/topic/${id}`
      this.resolveRouter(path)
    },
    onDeleteButton(id){
      //弹窗
      this.orderId = id
      this.centerDialogVisible = true;
    },
    deleteTopics(){
      deleteTopics(this.orderId).then(() => {
        this.$message({
          message: '刪除成功',
          type: "success"
        });
        this.getTopics();
      }).finally(()=>{
        this.centerDialogVisible = false;
      })
    },
    getTopics() {
      let formLabelAlign = {
        numberLike: this.listQuery.numberLike,
        gradeId: this.listQuery.gradeId,
        lang: this.listQuery.lang,
        scope: this.listQuery.scope,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page-1,
        _limit: this.listQuery._limit,
      };
      getTopics(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-content-box{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(5, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 170px !important;
}
.page-content-row>div:nth-last-child(1), .page-content-row>div:nth-last-child(2){ 
  width: 100px !important;
}
.describe-text{
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 3; /* 最多显示三行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  line-height: 1.5; 
}
</style>